import { render, staticRenderFns } from "./CustomKeyValuePair.vue?vue&type=template&id=3ae0d008"
import script from "./CustomKeyValuePair.vue?vue&type=script&lang=js"
export * from "./CustomKeyValuePair.vue?vue&type=script&lang=js"
import style0 from "./CustomKeyValuePair.vue?vue&type=style&index=0&id=3ae0d008&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports